import React from "react";
import AllLocations from "./LocationModule/AllLocations";

const Locations = () => {
  return (
    <div>
      <AllLocations />
    </div>
  );
};

export default Locations;
